import i18n from "@/i18n";
import { SolutionTypeEnum } from "@/services/solutions/types";

export const solutionFields = [
    {
        key: "status",
        label: ""
    },
    {
        key: "name",
        label: i18n.t("common.name"),
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "type",
        label: i18n.t("common.type"),
        formatter: solutionType
    },
    {
        key: "actions",
        label: ""
    },
    {
        key: "drag",
        label: "",
        class: "draggable-btn-cell"
    }
];

export const solutionFieldsEditor = [
    {
        key: "status",
        label: ""
    },
    {
        key: "name",
        label: i18n.t("common.name"),
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "type",
        label: i18n.t("common.type"),
        formatter: solutionType
    },
    {
        key: "actions",
        label: ""
    }
];

function solutionType(type: number) {
    return i18n.t(`solution.${SolutionTypeEnum[type]}`);
}
